export const LicenseInformationTab = ({
  licenseCode,
  setLicenseCode,
  licenseDescription,
  setLicenseDescription,
  licenseNumber,
  setLicenseNumber,
  licenseQualified,
  setLicenseQualified,
  licenseExpirationDate,
  setLicenseExpirationDate,

  isEditMode
}) => {
  return (
    <div className="accounts-tab column" style={{ marginTop: "20px" }}>

      {/* Row 1: Code, Description, Number */}
      <div className="accounts-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">License Code</div>
          <div className="info-item-input">
            <input
              placeholder="License Code"
              readOnly={!isEditMode}
              value={licenseCode}
              onChange={(e) => setLicenseCode(e.target.value)}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Description</div>
          <div className="info-item-input">
            <input
              placeholder="Description"
              readOnly={!isEditMode}
              value={licenseDescription}
              onChange={(e) => setLicenseDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">License Number</div>
          <div className="info-item-input">
            <input
              placeholder="License Number"
              readOnly={!isEditMode}
              value={licenseNumber}
              onChange={(e) => setLicenseNumber(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Row 2: Expiration */}
      <div className="accounts-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">Expiration Date</div>
          <div className="info-item-input">
            <input
              type="date"
              readOnly={!isEditMode}
              value={licenseExpirationDate}
              onChange={(e) => setLicenseExpirationDate(e.target.value)}
            />
          </div>
        </div>

      </div>

      {/* Row 3: Qualified */}
      <div className="accounts-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">Qualified</div>
          <div className="info-item-input" style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <input
              type="checkbox"
              id="licenseQualifiedCheckbox"
              style={{ width: "20px", height: "20px", margin: "0" }}
              disabled={!isEditMode}
              checked={licenseQualified}
              onChange={(e) => setLicenseQualified(e.target.checked)}
            />
            <label htmlFor="licenseQualifiedCheckbox" style={{ marginLeft: "10px", fontSize: "14px" }}>
              Is Qualified
            </label>
          </div>
        </div>

      </div>

    </div>
  );
};